if (!customElements.get('buy-now-button')) {
  customElements.define(
    'buy-now-button',
    class BuyNowButton extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.sectionId = this.dataset.sectionId;
        this.button?.addEventListener('click', this.onClick.bind(this));

        if (typeof subscribe === 'function') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data?.sectionId !== this.sectionId) return;
            this.toggleAvailability(event.data.variant);
          });
        }
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber?.();
      }

      // Mirror the native add-to-cart button: disable when the variant is unavailable.
      toggleAvailability(variant) {
        if (!this.button) return;
        this.button.disabled = !variant || variant.available === false;
      }

      get form() {
        return (
          document.getElementById(this.dataset.formId) ||
          this.closest('product-form')?.querySelector('form')
        );
      }

      get variantId() {
        const input = this.form?.querySelector('[name="id"]');
        return input ? input.value : null;
      }

      get quantity() {
        const field = document.getElementById(`Quantity-${this.dataset.sectionId}`);
        const value = field ? parseInt(field.value, 10) : 1;
        return Number.isNaN(value) || value < 1 ? 1 : value;
      }

      onClick(event) {
        event.preventDefault();
        if (this.button.disabled || this.button.getAttribute('aria-disabled') === 'true') return;
        const id = this.variantId;
        if (!id) return;

        this.button.setAttribute('aria-disabled', 'true');
        this.button.classList.add('loading');

        const body = JSON.stringify({ items: [{ id: Number(id), quantity: this.quantity }] });

        fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              // Cart error (e.g. sold out) — re-enable and stop.
              this.reset();
              return;
            }
            const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
            window.location.href = `${root}checkout`;
          })
          .catch((error) => {
            console.error(error);
            this.reset();
          });
      }

      reset() {
        this.button.removeAttribute('aria-disabled');
        this.button.classList.remove('loading');
      }
    }
  );
}
